export default __webpack_public_path__ + "static/about-us-banner-new-c2708bc8b8f11dca24f7cfb85d88c797.jpg";